import axiosInstance from "../../../api/axiosInstance";
import { toast } from "react-toastify";

export const clientInfo = async ({ accessToken }) => {
  try {
    const response = await axiosInstance.get(
      "/user/@me/profile",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const getTransactionList = async (accessToken) => {
  try {
    const response = await axiosInstance.get(
      "/user/@me/transactions",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response) {
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const getWalletAmount = async ({ username, accessToken }) => {
  try {
    const response = await axiosInstance.get(
      `/business/@${username}/wallet`,
      {
        headers: {
          Authorization: ` Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.log(error.response);
  }
};

export const updateClientInfo = async ({ accessToken, data }) => {
  try {
    const response = await axiosInstance.patch(
      "/user/@me/profile",
      data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      const serverError = error.response.data?.error;
      toast.error(serverError || "خطا در بروزرسانی اطلاعات");
    } else {
      toast.error("مشکل شبکه یا عدم دسترسی به سرور");
    }
  }
};

export const updateClientPassword = async ({
  accessToken,
  currentPassword,
  newPassword,
  confirmPassword,
}) => {
  try {
    const response = await axiosInstance.post(
      "/auth/password",
      {
        oldPassword: currentPassword,
        password: newPassword,
        confirmPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    } else {
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
    return null;
  }
};
